module.exports = require('./helpers/bundle-url').getBundleURL('fJUuz') + "logo.c51670a8.svg";